import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 判断是否为移动设备
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
	navigator.userAgent.toLowerCase()
);

const router = new Router({
	routes: [
		// 根路径重定向将在路由守卫中处理
		{path: '/',redirect: to => {
			// 如果是移动设备，直接跳转到首页
			if (isMobile) {
				return '/index';
			}
			
			// 非移动设备时，检查用户是否已登录
			const isLoggedIn = localStorage.getItem('virbac-token')
			// 已登录则跳转到首页，未登录则跳转到登录页
			return isLoggedIn ? '/index' : '/login'
		}},
		{path: '/login',component:()=>import("./pages/login.vue"),name:"登录页"},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"商综列表页", meta: { requiresAuth: true }},
		{path: '/article',component:()=>import("./pages/article.vue"),name:"商综详情页", meta: { requiresAuth: true }},
	]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
	// 如果是移动设备，跳过身份验证
	if (isMobile) {
		next();
		return;
	}
	
	// 检查路由是否需要登录权限
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// 检查用户是否已登录
		const isLoggedIn = localStorage.getItem('virbac-token')
		if (!isLoggedIn) {
			// 如果没有登录，重定向到登录页面
			next({
				path: '/login'
			})
		} else {
			// 已登录，继续导航
			next()
		}
	} else {
		// 不需要登录权限的路由直接放行
		next()
	}
})

export default router